export const JWT_COOKIE = 'GAME_JWT';